import { CheckCircle2, Circle, Loader2 } from "lucide-react";

const DEFAULT_PHASES = [
  "Ingestion",
  "Analysis",
  "Tool Execution",
  "Generation",
  "Validation",
  "Formatting",
];

interface ExecutionStepperProps {
  currentPhase: number; // -1 = not started, 0-5 = current phase, 6 = all complete
  phases?: string[];
}

export function ExecutionStepper({ currentPhase, phases }: ExecutionStepperProps) {
  if (currentPhase < 0) return null;

  const phaseLabels = phases || DEFAULT_PHASES;

  return (
    <div className="rounded-lg border bg-card p-4">
      <p className="text-xs font-medium text-muted-foreground uppercase tracking-wider mb-3">
        Execution Progress
      </p>
      <div className="flex items-center gap-1">
        {phaseLabels.map((phase, i) => {
          const isComplete = i < currentPhase;
          const isCurrent = i === currentPhase;
          return (
            <div key={phase} className="flex-1 flex flex-col items-center gap-1.5">
              <div className={`h-6 w-6 rounded-full flex items-center justify-center ${
                isComplete ? "bg-success/20" : isCurrent ? "bg-info/20" : "bg-muted"
              }`}>
                {isComplete ? (
                  <CheckCircle2 className="h-3.5 w-3.5 text-success" />
                ) : isCurrent ? (
                  <Loader2 className="h-3.5 w-3.5 text-info animate-spin" />
                ) : (
                  <Circle className="h-3 w-3 text-muted-foreground" />
                )}
              </div>
              <span className={`text-[9px] text-center leading-tight ${
                isComplete ? "text-success font-medium" : isCurrent ? "text-info font-medium" : "text-muted-foreground"
              }`}>
                {phase}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
}
